<template>
  <div>
    <div class="row">
      <div class="col-lg-3 col-xs-12"></div>
      <div class="col-xs-12 col-lg-6">
        <div class="card card-body">
          <div v-if="job.mandatory_portfolio">
            <label> Portifólio (opcional) </label>
            <input
              type="text"
              class="form-control"
              v-model="candidates.personal_portfolio"
              placeholder="Linkedin, Portifólio ou Github"
            />
          </div>
          <div class="mt-3" v-if="job.mandatory_portfolio">
            <label> Site pessoal (opcional)</label>
            <input
              type="text"
              class="form-control"
              v-model="candidates.personal_site"
              placeholder="https://seusite.com.br"
            />
          </div>
          <div class="mt-3" v-if="job.mandatory_cv">
            <label>Envie seu currículo</label>
            <CurriculumUpload v-if="job.mandatory_cv" />
            <span class="help-block">
              É necessário que você faça o upload do seu CV.
            </span>
          </div>
          <button
            :disabled="load"
            @click="save"
            type="button"
            class="btn btn-success mt-3 right"
          >
            <div v-show="load" class="spinner-border text-light" role="status">
              <span class="sr-only"></span>
            </div>
            {{ !load ? "Salvar" : "" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CurriculumUpload from "components/CurriculumUpload.vue";
export default {
  components: { CurriculumUpload },
  props: ["job"],
  mounted() {
    eventBus.$on("curriculum_load", (index) => {
      this.send_cv = true;
    });

    eventBus.$on("curriculum_load", (value) => {
      if (!value) this.$toast.success("Upload do currículo feito com sucesso.");
      this.load = value;
    });
  },
  data: () => ({
    load: false,
    send_cv: false,
    candidates: {
      personal_portfolio: "",
      personal_site: "",
    },
  }),
  methods: {
    save() {
      this.load = true;
      if (!this.send_cv && this.job.mandatory_cv) {
        this.$toast.error("O envio do currículo é obrigatorio");
        this.load = false;
        return;
      }

      axios
        .put("/candidates", {
          candidates: this.candidates,
        })
        .then((response) => {
          if (response.data.status == true) {
            this.$toast.success("Dados salvos com sucesso");
            eventBus.$emit("formQuestionScreen", { status: true });
            return;
          }

          this.$toast.error("Erro al salvar os dados");
        });
    },
  },
};
</script>

<style>
</style>